export default "__VITE_ASSET__Bm31ziqK__"